export const cyrillicFonts = [
  {
    className: 'opensans',
    fontFamily: 'Open Sans',
    fontWeight: 400,
  },
  {
    className: 'montserrat',
    fontFamily: 'Montserrat',
    fontWeight: 400,
  },
  {
    className: 'playfairdisplay',
    fontFamily: 'Playfair Display',
    fontWeight: 400,
  },
  {
    className: 'oswald',
    fontFamily: 'Oswald',
    fontWeight: 400,
  },
  {
    className: 'prostoone',
    fontFamily: 'Prosto One',
    fontWeight: 400,
  },
  {
    className: 'philosopher',
    fontFamily: 'Philosopher',
    fontWeight: 400,
  },
  {
    className: 'marmelad',
    fontFamily: 'Marmelad',
    fontWeight: 400,
  },
  {
    className: 'robotocondensed',
    fontFamily: 'Roboto Condensed',
    fontWeight: 400,
  },
  {
    className: 'robotoslab',
    fontFamily: 'Roboto Slab',
    fontWeight: 400,
  },
  {
    className: 'alice',
    fontFamily: 'Alice',
    fontWeight: 400,
  },
  {
    className: 'raleway',
    fontFamily: 'Raleway',
    fontWeight: 400,
  },
  {
    className: 'nunito',
    fontFamily: 'Nunito',
    fontWeight: 400,
  },
  {
    className: 'comfortaa',
    fontFamily: 'Comfortaa',
    fontWeight: 400,
  },
  {
    className: 'yanonekaffeesatz',
    fontFamily: 'Yanone Kaffeesatz',
    fontWeight: 400,
    pro: true,
  },
  {
    className: 'arsenal',
    fontFamily: 'Arsenal',
    fontWeight: 400,
    pro: true,
  },
  {
    className: 'didactgothic',
    fontFamily: 'Didact Gothic',
    fontWeight: 400,
    pro: true,
  },
  {
    className: 'lobster',
    fontFamily: 'Lobster',
    fontWeight: 400,
    pro: true,
  },
  {
    className: 'balsamiqsans',
    fontFamily: 'Balsamiq Sans',
    fontWeight: 400,
    pro: true,
  },
  {
    className: 'pacifico',
    fontFamily: 'Pacifico',
    fontWeight: 400,
    pro: true,
  },
  {
    className: 'russoone',
    fontFamily: 'Russo One',
    fontWeight: 400,
    pro: true,
  },
];
